import React, { FC } from 'react';
import { features } from 'texts/texts';
import { TextWithStyle } from 'components/TextWithStyle';
import { SEO } from 'components/seo/SEO';
import { breadcrumbJsonLd } from 'components/seo/organizationSchema';
import routeManifest from 'routes/routeManifest.json';
import '../Features.css';

const route = routeManifest.find((r) => r.path === '/features/vote')!;
const breadcrumbs = breadcrumbJsonLd([
  { name: 'Home', path: '/' },
  { name: 'Features', path: '/features' },
  { name: 'Vote', path: '/features/vote' },
]);

// TODO: load feature requests and votes from the database.
export const FeatureVoting: FC = () => {
  return (
    <div className="features-content-container">
      <SEO title={route.title} description={route.description} path={route.path} jsonLd={[breadcrumbs]} />
      <div className="features-header">
        <h1>
          {features.voting.title.map((part, index) => (
            <TextWithStyle key={index} text={part.text} style={part.style} />
          ))}
        </h1>
        <p>{features.voting.description}</p>
      </div>
      <p className="features-empty">Coming soon 🌱</p>
    </div>
  );
};
